import type { ComponentType } from "svelte";
import HelloWorld from "../../components/Steps/HelloWorld.svelte";
import CampaignTeaser from "../../components/Steps/CampaignTeaser.svelte";
import Landing from "../../components/Steps/Landing.svelte";
import SkippedLanding from "../../components/Steps/SkippedLanding.svelte";
import Success from "../../components/Steps/Success.svelte";
import UserDetails from "../../components/Steps/UserDetails.svelte";
import GenericErrorPage from "../../components/Steps/GenericErrorPage.svelte";
import Rules from "../../components/Steps/Rules.svelte";
import AddressDetails from "../../components/Steps/AddressDetails.svelte";
import ReviewDetails from "../../components/Steps/ReviewDetails.svelte";
import Menu from "../../components/Steps/Menu.svelte";
import VerifyEmail from "../../components/Steps/VerifyEmail.svelte";
import Reminder from "../../components/Steps/Reminder.svelte";
import CheckAge from "../../components/Steps/CheckAge.svelte";
import Survey from "../../components/Steps/Survey.svelte";
import EntryGate from "../../components/Steps/EntryGate.svelte";
import Progress from "../../components/Steps/Progress.svelte";
import SecondaryChannelAuth from "../../components/Steps/SecondaryChannelAuth.svelte";
import Info from "../../components/Steps/Info.svelte";
import SkillTest from "../../components/Steps/SkillTest.svelte";
import DeliveryZones from "../../components/Steps/DeliveryZones.svelte";
import NoSupport from "../../components/Steps/NoSupport.svelte";
import UploadFile from "../../components/Steps/UploadFile.svelte";
import InvalidEntry from "../../components/Steps/InvalidEntry.svelte";
import CallOfDutyAuth from "../../components/Steps/CallOfDutyAuth.svelte";

export const pageMap: { [key: string]: ComponentType } = {
  HelloWorld,
  CampaignTeaser,
  Landing,
  SkippedLanding,
  Success,
  UserDetails,
  GenericErrorPage,
  AddressDetails,
  Rules,
  Review: ReviewDetails,
  Menu,
  VerifyEmail,
  Reminder,
  CheckAge,
  Survey,
  EntryGate,
  Progress,
  LinkedInAuth: SecondaryChannelAuth, // remove after integration is done
  SecondaryChannelAuth,
  Info,
  NoSupport,
  SkillTest,
  DeliveryZones,
  UploadFile,
  InvalidEntry,
  CallOfDutyAuth
};
